var hoverButtonProduct="<button class='swell-buy-product-btn'>REDEEM NOW</button>"
class RedemptionProduct {
    constructor(productList,rewardsRedemptionPrudoct) {
        this.productList=productList;
        this.rewardsRedemptionPrudoct=rewardsRedemptionPrudoct;
    }
    renderProductList() {
        this.productList.forEach( product => {
            if (product.discount_type==="product") {
                console.log(product.applies_to_id)
                        $(".redemption-products-grid").append(
                          $("<div>",{"data-variant-id":product.applies_to_id, "data-hide-logged-out": "true"}
                            ).addClass("product swell-buy-product-btn").append(
                            $("<div>").append(
                                $("<img>", {src:product.background_image_url})
                            ).addClass("image-wrapper"),
                            $("<div>" 
                                
                                ).addClass("product-text-div products__item--info").append(
                                $("<button>").text("REDEEM NOW").addClass("products__item--btns"),
                                $("<p>").text(product.name).addClass("text-title title"),
                                $("<p>").text(product.cost_text).addClass("text-points"),
                                $("<span>").addClass("swell-sale-item").text("Sale")
                            )
                        ))
    $(".swell-buy-product-btn").hide();
        
            }
        });
        $("<button>").addClass
        var newscript = document.createElement('script');
                    newscript.type = 'text/javascript';
                    newscript.async = true;
                    newscript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
                 (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(newscript);
        setTimeout(function(){
                $('.redemption-products-grid').slick({
                    centerMode: false,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows:true,
                    dots: true,
                    prevArrow: "<div><</div>",
                    nextArrow: "<div>></div>",
                    responsive: [
                    {breakpoint: 851, settings: { arrows: false, slidesToShow: 1, slidesToScroll: 1 ,centerMode: true,dots:true,
                    centerPadding: '8%', infinite: true}} 
                    ]
                });  }, 300);

    }
    renderProductRedemptionsPopup(Customer){
        if(Customer.created_at!==undefined )
        {  
            this.productList.forEach( product => {
               $(".product").hover(
                function() {
                    $(this).children(".product-text-div").children(".swell-buy-product-btn").show()

                },
               function() {
                  $(this).children(".product-text-div").children(".swell-buy-product-btn").hide()
                 }

                )
               })
        }
    }
}

// class RedemptionProducts{
//   constructor(activeRedemption){
//     this.activeRedemption=activeRedemption;
//   }
//   renderProductRedemptions(){ 
//       this.activeRedemption.forEach((redemtion,index) =>
//       {
//         if(redemtion.discount_type=="product")
//         {
//           $(".swell-redemtion-carousel").append(
//             $("<div>", {"data-variant-id":redemtion.applies_to_id, "data-hide-logged-out":"true"}).addClass(
//               "swell-redemtion swell-buy-product-btn").append(
//               $("<div>").addClass("div-for-img").append(
//                 $("<img>",{src: redemtion.background_image_url}).addClass("swell-carusel-img")), 
//                 $("<div>").addClass("div-to-text").append(
//                     $("<h5>").text(redemtion.name).addClass("redemtion-product-name"),
//                     $("<h5>").text(redemtion.cost_text)),  
//                 $("<h4>").addClass(`h4-num${index} clear-button`).text("REDEEM NOW")))
//         }
//       });
//       $(".swell-redemtion-carousel .clear-button").mouseover(function(){
//       $(this).css("color","black")
//       $(this).css("background-color","#fdbd3b")
//     }).mouseout(function(){
//       $(this).css("color","#fbbc4c")
//       $(this).css("background-color","unset")
//     })
//      if($(".swell-redemtion-carousel div").length > 0){
//       var newscript = document.createElement('script');
//                 newscript.type = 'text/javascript';
//                 newscript.async = true;
//                 newscript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
//              (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(newscript);
//       setTimeout(function(){
//             $(".swell-redemtion-carousel").slick({
//                 slidesToShow: 4,
//                 slidesToScroll: 4,
//                 dots: false,
//                 arrows: true,
//                 nextArrow: '<span class="slick-next slick-arrow next-btn"></span>',
//                 prevArrow: '<span class="slick-prev slick-arrow prev-btn"></span>',
//                 responsive: [
//                   {breakpoint: 900,
//                    settings: {
//                     slidesToShow:2,
//                     slidesToScroll: 2,
//                     centerMode: true,
//                     centerPadding: '13%',
//                     infinite: true,
//                     arrows: false,
//                    }},
//                    {breakpoint: 550,
//                    settings: {
//                     slidesToShow:2,
//                     slidesToScroll: 2,
//                     centerMode: true,
//                     centerPadding: '8%',
//                     infinite: true,
//                     arrows: false,
//                    }},
//                ]});
//             }, 3000);
//      }
//   }
// }
// Collapse




